import { HeadcountChangesInitialState } from './headcountChanges.types';
import { HeadcountChangesKey } from './headcountChanges.const';
import {
  fetchHeadcountChanges,
  saveHeadcountChanges,
} from './headcountChanges.thunks';
import _ from 'lodash';
import { createSliceCustom } from '../../utils/tests/createSliceCustom';

export const headcountChangesInitialState: HeadcountChangesInitialState = {
  headcountChanges: [],
  isLoading: false,
  previousHeadcountChanges: [],
  activeId: '',
};

export const returns = createSliceCustom({
  name: HeadcountChangesKey,
  initialState: headcountChangesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeadcountChanges.pending, (state, { meta }) => {
        state.isLoading = true;
        state.headcountChanges = [];
        state.activeId = meta.arg.activeId;
      })

      .addCase(fetchHeadcountChanges.fulfilled, (state, { payload }) => {
        state.headcountChanges = payload;
        state.isLoading = false;
      })

      .addCase(fetchHeadcountChanges.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(saveHeadcountChanges.pending, (state) => {
        state.previousHeadcountChanges = state.headcountChanges;
      })

      .addCase(saveHeadcountChanges.fulfilled, (state, { payload }) => {
        state.headcountChanges = payload;
        state.previousHeadcountChanges = [];
      })

      .addCase(saveHeadcountChanges.rejected, (state) => {
        if (state.previousHeadcountChanges)
          state.headcountChanges = state.previousHeadcountChanges;
        state.previousHeadcountChanges = [];
      });
  },
});

export const headcountChangesSlice = returns.slice;
export const headcountChangesReducers = returns.reducers;
export const headcountChangesExtraReducers = returns.extraReducers;
